{
 "note": "made by tools/make-ride-sprites.py from assets/vehicles/side (purchased pack); do not edit",
 "image": "/sprites/ride.png",
 "ppm": 56,
 "facing": "right (the front is at the right edge); mirror for leftward traffic",
 "vehicles": {
  "cab": {
   "lengthM": 4.6,
   "role": "the app cab: a white sedan",
   "w": 258,
   "h": 84,
   "fps": 8,
   "frames": [
    [
     0,
     0
    ],
    [
     260,
     0
    ],
    [
     520,
     0
    ],
    [
     780,
     0
    ],
    [
     1040,
     0
    ]
   ]
  },
  "sedan": {
   "lengthM": 4.6,
   "role": "traffic",
   "w": 258,
   "h": 84,
   "fps": 8,
   "frames": [
    [
     1300,
     0
    ],
    [
     1560,
     0
    ],
    [
     0,
     86
    ],
    [
     260,
     86
    ],
    [
     520,
     86
    ]
   ]
  },
  "box_truck": {
   "lengthM": 6.2,
   "role": "traffic",
   "w": 347,
   "h": 146,
   "fps": 8,
   "frames": [
    [
     780,
     86
    ],
    [
     1129,
     86
    ],
    [
     1478,
     86
    ],
    [
     0,
     234
    ],
    [
     349,
     234
    ]
   ]
  },
  "container_truck": {
   "lengthM": 12.0,
   "role": "traffic, rare",
   "w": 672,
   "h": 204,
   "fps": 8,
   "frames": [
    [
     698,
     234
    ],
    [
     1372,
     234
    ],
    [
     0,
     440
    ],
    [
     674,
     440
    ],
    [
     1348,
     440
    ]
   ]
  },
  "bus": {
   "lengthM": 10.5,
   "role": "traffic; recoloured red",
   "w": 588,
   "h": 219,
   "fps": 8,
   "frames": [
    [
     0,
     646
    ],
    [
     590,
     646
    ],
    [
     1180,
     646
    ],
    [
     0,
     867
    ],
    [
     590,
     867
    ]
   ]
  }
 }
}